import {
  LOGO_BRT,
  LOGO_COLIS_PRIVE,
  LOGO_COLISSIMO,
  LOGO_DHL,
  LOGO_DPD,
  LOGO_HERMES,
  LOGO_POINTRELAIS,
  LOGO_POST,
} from 'shared/consts/deliveryLogos'
import { walkOverPropsRecursively } from 'shared/utils/objectUtils'
import logoBrt from 'views/assets/images/logos/logo-brt-it.svg'
import logoCollis from 'views/assets/images/logos/logo-colis-prive-fr.svg'
import logoColissimo from 'views/assets/images/logos/logo-colissimo-fr.svg'
import logoDhl from 'views/assets/images/logos/logo-dhl.svg'
import logoDpd from 'views/assets/images/logos/logo-dpd.svg'
import logoHermes from 'views/assets/images/logos/logo-hermes.svg'
import logoPointrelais from 'views/assets/images/logos/logo-pointrelais-fr.svg'
import logoPost from 'views/assets/images/logos/logo-post.svg'

const DELIVERY_LOGOS = {
  [LOGO_DHL]: logoDhl,
  [LOGO_HERMES]: logoHermes,
  [LOGO_POST]: logoPost,
  [LOGO_COLISSIMO]: logoColissimo,
  [LOGO_POINTRELAIS]: logoPointrelais,
  [LOGO_BRT]: logoBrt,
  [LOGO_DPD]: logoDpd,
  [LOGO_COLIS_PRIVE]: logoCollis,
}

export const resolveImages = deliveryCosts =>
  walkOverPropsRecursively(
    { transform: prop => DELIVERY_LOGOS[prop] || prop },
    deliveryCosts
  )
